export default __webpack_public_path__ + "static/media/popularImage.777f57a7.jpg";